export const kitchen =
  'https://png.pngtree.com/png-vector/20190226/ourmid/pngtree-cooking-and-kitchen-icon-png-image_719697.jpg';

export const washroom = 'https://cdn-icons-png.flaticon.com/512/75/75310.png';

export const parking =
  'https://cdn-icons-png.flaticon.com/512/4162/4162840.png';
